import { useMemo } from "react";

/**
 * Computes per-vehicle deal metrics from a /api/vehicles/{id} response.
 * Returns: { repair_total, total_investment, sale_price, profit, roi, daysHeld, accent }
 */
export function useDealCalculations(data) {
  return useMemo(() => {
    if (!data) return null;
    const { vehicle: v, costs, sale } = data;
    const repair_total = (costs.repair_total || 0) + (v.misc_costs || 0);
    const start = new Date(v.purchase_date || v.created_at);
    const end = sale ? new Date(sale.sale_date || sale.created_at) : new Date();
    const daysHeld = Math.max(0, Math.round((end - start) / (1000 * 60 * 60 * 24)));
    const total_investment = costs.total_investment || 0;
    const sale_price = sale?.sale_price || 0;
    const profit = sale ? sale_price - total_investment : null;
    const roi = sale && total_investment > 0 ? (profit / total_investment) * 100 : null;

    let accent = "";
    if (profit !== null) {
      accent = profit >= 0
        ? "text-emerald-600 dark:text-emerald-400"
        : "text-red-600 dark:text-red-400";
    }
    return { repair_total, total_investment, sale_price, profit, roi, daysHeld, accent };
  }, [data]);
}
